import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AnaBizPassengerInfo } from '@app/anabiz-payment-input/container';
import { SupportComponent } from '@lib/components/support-class';
import { AswValidators } from '@lib/helpers';
import { CommonLibService } from '@lib/services';
import {
  InitializationResponseDataAnaBizContextAuthInfoCompanyInfoA,
  InitializationResponseDataAnaBizContextAuthInfoCompanyInfoC,
  InitializationResponseDataAnaBizContextAuthInfoCompanyManagementCodeInfoTexts,
} from 'src/sdk-initialization';

@Component({
  selector: 'asw-anabiz-payment-input-corporate-management-code',
  templateUrl: './anabiz-payment-input-corporate-management-code.component.html',
  styleUrls: ['./anabiz-payment-input-corporate-management-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnabizPaymentInputCorporateManagementCodeComponent extends SupportComponent {
  public inputCorporateCode!: FormGroup;

  corpManagementCodeForm = new FormArray<FormGroup>([]);
  // ANABiz搭乗者情報
  @Input() set anabizPassengerInfoList(value: Array<AnaBizPassengerInfo>) {
    this._anabizPassengerInfoList = value;
    value.forEach((traveler) => {
      this.corpManagementCodeForm.push(
        new FormGroup({
          companyManagementCode1: new FormControl(traveler.companyManagementCode1, AswValidators.alphaNumeric()),
          companyManagementCode2: new FormControl(traveler.companyManagementCode2, AswValidators.alphaNumeric()),
          companyManagementCode3: new FormControl(traveler.companyManagementCode3, AswValidators.alphaNumeric()),
          companyManagementCode4: new FormControl(traveler.companyManagementCode4),
        })
      );
    });
  }
  get anabizPassengerInfoList(): Array<AnaBizPassengerInfo> {
    return this._anabizPassengerInfoList;
  }
  private _anabizPassengerInfoList: Array<AnaBizPassengerInfo> = [];
  // 利用企業情報
  @Input() companyInfo?:
    | InitializationResponseDataAnaBizContextAuthInfoCompanyInfoC
    | InitializationResponseDataAnaBizContextAuthInfoCompanyInfoA;
  @Output() anabizPassengerInfoListChange = new EventEmitter<Array<AnaBizPassengerInfo>>();

  public corporateManagementCode4ComboOptions: Array<string> = [];
  public corporateManagementTextItems: Array<string> = [];
  public showLabel = false;
  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(private _common: CommonLibService, private _changeDetectorRef: ChangeDetectorRef) {
    super(_common);
    this.corporateManagementCode4ComboOptions =
      this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyManagementCodeInfo?.comboNames ?? [];

    this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyManagementCodeInfo?.texts?.forEach(
      (item, index) => {
        this.corporateManagementTextItems[index] = item.code ?? '';
      }
    );
    if (
      this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoA?.companyAdminCodeEditRestrict ===
      '1'
    ) {
      this.showLabel = true;
    }

    this._changeDetectorRef.markForCheck();
  }

  /**
   * 企業管理用コード1入力変更時実行関数
   * @param index 表示搭乗者の順番
   */
  companyManagementCode1Change(index: number) {
    this._anabizPassengerInfoList[index].companyManagementCode1 =
      this.corpManagementCodeForm.at(index).controls['companyManagementCode1'].value;
    this.anabizPassengerInfoListChange.emit(this._anabizPassengerInfoList);
  }

  /**
   * 企業管理用コード2入力変更時実行関数
   * @param index 表示搭乗者の順番
   */
  companyManagementCode2Change(index: number) {
    this._anabizPassengerInfoList[index].companyManagementCode2 =
      this.corpManagementCodeForm.at(index).controls['companyManagementCode2'].value;
    this.anabizPassengerInfoListChange.emit(this._anabizPassengerInfoList);
  }

  /**
   * 企業管理用コード3入力変更時実行関数
   * @param index 表示搭乗者の順番
   */
  companyManagementCode3Change(index: number) {
    this._anabizPassengerInfoList[index].companyManagementCode3 =
      this.corpManagementCodeForm.at(index).controls['companyManagementCode3'].value;
    this.anabizPassengerInfoListChange.emit(this._anabizPassengerInfoList);
  }

  /**
   * 企業管理用コード4入力変更時実行関数
   * @param index 表示搭乗者の順番
   */
  companyManagementCode4Change(index: number) {
    this._anabizPassengerInfoList[index].companyManagementCode4 =
      this.corpManagementCodeForm.at(index).controls['companyManagementCode4'].value;
    this.anabizPassengerInfoListChange.emit(this._anabizPassengerInfoList);
  }
}
